var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.32323C2 3.64982 2.22523 3.09426 2.67568 2.65657C3.12612 2.21885 3.71172 2 4.43243 2C5.14029 2 5.71299 2.21547 6.15058 2.64646C6.60102 3.09091 6.82625 3.67002 6.82625 4.38384C6.82625 5.0303 6.60747 5.56901 6.16988 6C5.71944 6.44444 5.12741 6.66667 4.39382 6.66667H4.37452C3.66666 6.66667 3.09396 6.44444 2.65637 6C2.21878 5.55556 2 4.99663 2 4.32323ZM2.25097 22V8.50505H6.53668V22H2.25097ZM8.9112 22H13.1969V14.4646C13.1969 13.9933 13.2484 13.6296 13.3514 13.3737C13.5315 12.9158 13.805 12.5286 14.1718 12.2121C14.5386 11.8956 14.9987 11.7374 15.5521 11.7374C16.9936 11.7374 17.7143 12.7542 17.7143 14.7879V22H22V14.2626C22 12.2694 21.5496 10.7576 20.6486 9.72727C19.7477 8.69697 18.5573 8.18182 17.0772 8.18182C15.417 8.18182 14.1236 8.92929 13.1969 10.4242V10.4646H13.1776L13.1969 10.4242V8.50505H8.9112C8.93693 8.93602 8.94981 10.2761 8.94981 12.5253C8.94981 14.7744 8.93693 17.9326 8.9112 22Z",
    fill: "#697077"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.3372479b.svg";
export { ForwardRef as ReactComponent };